import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend, { HttpBackendOptions } from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const backend: HttpBackendOptions = {
  loadPath: '/locales/{{lng}}/{{ns}}.json',
};

export const supportedLngs = ['en'];

const isTest = import.meta.env.MODE === 'test';

// Skip http in test, avoid error spam in output
if (!isTest) {
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  i18n.use(Backend);
}

const init = i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    backend,
    supportedLngs,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export { init as i18nInitPromise };
export default i18n;

// Debug mode, keys are shown
// i18n.changeLanguage('cimode');
